import React from 'react';
import { DOWNGRADE_PLAN, UPGRADE_PLAN } from '../PlanSubscription/const';
import { Button } from 'antd';
import moment from 'moment';

const CardSubscription = ({
  type,
  actualPlan,
  upgradePlan,
  name,
  includes = [],
  pricePackage,
  packageId,
  onOpenModalCanceledPlan,
  onOpenModalConfirmUpgrade,
  onDownActualOrUpgradePlan,
  noneActions = false,
  availableUntil,
  disabled,
  billDue,
  tenant,
}) => {
  const CUSTOM_PACKAGE_MULTI = 7;
  const CUSTOM_PACKAGE_SINGLE = 8;

  const tenantTotalPrice = tenant?.total_due;

  const pricePerMonth =
    packageId === CUSTOM_PACKAGE_SINGLE || packageId === CUSTOM_PACKAGE_MULTI
      ? pricePackage
      : (tenantTotalPrice + pricePackage).toFixed(2);

  const getButtonText = () => {
    if (actualPlan) {
      return 'Cancel subscription';
    }

    if (onDownActualOrUpgradePlan) {
      const action = onDownActualOrUpgradePlan({ type: type });
      if (action === undefined) {
        return `Select ${name} plan`;
      }
      return `${action} subscription`;
    }

    return `Select ${name} plan`;
  };

  const handleButtonClick = () => {
    if (actualPlan) {
      onOpenModalCanceledPlan();
    } else if (!packageId || onDownActualOrUpgradePlan({ type: type }) === undefined) {
      // If no packageId, this is an initial plan selection
      onOpenModalConfirmUpgrade({
        subscription: type,
        action: 'SELECT',
      });
    } else {
      // Existing upgrade/downgrade logic
      onOpenModalConfirmUpgrade({
        subscription: packageId,
        action: upgradePlan ? UPGRADE_PLAN : DOWNGRADE_PLAN,
      });
    }
  };

  return (
    <div
      key={type}
      className={`subscriptionSetting_plan ${actualPlan ? 'subscriptionSetting_plan_actual' : ''} ${
        upgradePlan ? 'subscriptionSetting_plan_upgrade' : ''
      }`}>
      {actualPlan && (
        <div className="subscriptionSetting_plan_item_actual">
          <p>Actual subscription</p>
        </div>
      )}
      <div className="subscriptionSetting_plan_item">
        <div>
          <p>Subscription</p>
          <strong>{name}</strong>
        </div>
        <div>
          {includes.length > 0 && (
            <>
              <p>Report types included</p>
              <div className="subscriptionSetting_plan_info_includes">
                {includes.map(includeReport => (
                  <strong key={includeReport}>{includeReport}</strong>
                ))}
              </div>
            </>
          )}
        </div>
        {billDue !== null && (
          <>
            <div>
              <p>Due Date</p>
              <strong>{billDue?.due_date ? moment(billDue.due_date).format('DD-MM-YYYY') : ''}</strong>
            </div>
            <div>
              <p>Writers Licenses</p>
              <strong>
                {billDue?.count_nurse_writer || 0}/{billDue?.restriction?.max_nurse_writer || 9} writers used: $
                {billDue?.price_nurse_writer || 0}/user
              </strong>
            </div>
            <div>
              <p>Roles Reviewers</p>
              <strong>
                {billDue?.count_reviewers}/{billDue?.restriction?.max_reviewers || 5} reviewers used: $
                {billDue?.price_reviewers || 0}/mo
              </strong>
            </div>
          </>
        )}
      </div>
      <div className="subscriptionSetting_plan_item">
        <div>
          <p className="subscriptionSetting_plan_info_price">${pricePerMonth}</p>
          <p>
            <strong>per month</strong>
          </p>
          <p>
            <strong>{availableUntil}</strong>
          </p>
        </div>
        <div>
          {!noneActions && (
            <Button
              type="primary"
              className={`${upgradePlan ? 'green-btn' : 'purple-btn-outline'}`}
              disabled={disabled}
              onClick={handleButtonClick}>
              {getButtonText()}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default CardSubscription;
